import React from "react";

import { basicNumberComparator } from "utils/comparatorUtils";
import { CIPAnalyticsCleaningTableStrings } from "constants/constantStrings";
import { PALE_TEAL_COLOR } from "constants/globalConstants";

import DownIcon from "assets/SvgIcon/DownIcon";
import { getTwoDecimalPoint } from "utils/utils";

const dropDownIcon = requirement => {
  const increase = requirement.toLowerCase().includes("increase");
  const iconClasses = `${increase ? "rotate" : ""}`;
  return <DownIcon classes={iconClasses} />;
};
const customCellRenderer = params => (
  <div className="flex-ai-center custom-table-cell-position cross-icon-Width">
    {dropDownIcon(params.value)} {params.value}
  </div>
);
const CLEANING_REQUIRED_TABLE_COLUMNS = customSettings => [
  {
    field: "TagName",
    headerName: CIPAnalyticsCleaningTableStrings.Tag,
    editable: false,
    minWidth: customSettings ? 210 : "",
    flex: 1.2,
    sortable: customSettings,
    headerClass: "custom-header"
  },
  {
    field: "Cleaning_Requirements",
    headerName: CIPAnalyticsCleaningTableStrings.Cleaning_Requirements,
    editable: false,
    minWidth: customSettings ? 200 : "",
    flex: customSettings ? 1 : 1.2,
    headerClass: () => "cleaning-required--header-bg custom-header",
    cellStyle: { backgroundColor: PALE_TEAL_COLOR },
    sortable: customSettings,
    cellRenderer: customCellRenderer
  },
  {
    field: "Baseline_Value",
    headerName: CIPAnalyticsCleaningTableStrings.Baseline_Value,
    editable: false,
    minWidth: customSettings ? 180 : 110,
    flex: 1,
    sortable: customSettings,
    comparator: basicNumberComparator,
    valueFormatter: params => getTwoDecimalPoint(params.data.Baseline_Value),
    headerClass: "custom-header"
  },
  {
    field: "Current_Value",
    headerName: CIPAnalyticsCleaningTableStrings.Current_Value,
    editable: false,
    minWidth: customSettings ? 150 : "",
    flex: 1,
    headerClass: () => "cleaning-required--header-bg custom-header",
    cellStyle: { backgroundColor: PALE_TEAL_COLOR },
    sortable: customSettings,
    valueFormatter: params => getTwoDecimalPoint(params.data.Current_Value),
    comparator: basicNumberComparator
  },
  {
    field: "Percent_to_Initial",
    headerName: CIPAnalyticsCleaningTableStrings.Percent_to_Initial,
    editable: false,
    minWidth: customSettings ? 100 : "",
    flex: 1,
    sortable: customSettings,
    comparator: basicNumberComparator,
    valueFormatter: params => getTwoDecimalPoint(params.data.Percent_to_Initial),
    headerClass: "custom-header"
  }
];

export const getCleaningRequiredTableColDef = customSettings => CLEANING_REQUIRED_TABLE_COLUMNS(customSettings);
